import { render, staticRenderFns } from "./ProjectChangeName.vue?vue&type=template&id=b27de8c0&scoped=true"
import script from "./ProjectChangeName.vue?vue&type=script&lang=js"
export * from "./ProjectChangeName.vue?vue&type=script&lang=js"
import style0 from "./ProjectChangeName.vue?vue&type=style&index=0&id=b27de8c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27de8c0",
  null
  
)

export default component.exports